export default __webpack_public_path__ + "images/SpeakersPhotos/Lucía Marínez_WAM.jpg?ff48f36f";